var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleStore = function SvgGoogleStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "none",
    viewBox: "0 0 17 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#googleStore_svg__a)",
    d: "M.822.369a1.4 1.4 0 0 0-.32.971v15.322c-.02.352.095.7.32.971l.053.053L9.455 9.1v-.204L.874.316z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#googleStore_svg__b)",
    d: "M12.316 11.962 9.454 9.1v-.204l2.862-2.856.064.035 3.391 1.926c.972.546.972 1.448 0 2l-3.39 1.926z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#googleStore_svg__c)",
    d: "M12.38 11.927 9.472 9.019l-8.65 8.614a1.164 1.164 0 0 0 1.425.04l10.116-5.746"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#googleStore_svg__d)",
    d: "M12.38 6.075 2.247.322A1.12 1.12 0 0 0 .822.37l8.632 8.632z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.316 11.863 2.247 17.575a1.16 1.16 0 0 1-1.39 0l-.052.053.052.052a1.16 1.16 0 0 0 1.39 0l10.116-5.747z",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M.822 17.54a1.4 1.4 0 0 1-.32-.977v.099c-.019.352.095.7.32.971l.053-.052zM15.771 9.897l-3.455 1.966.064.064 3.391-1.949a1.23 1.23 0 0 0 .727-1 1.29 1.29 0 0 1-.727.919",
    opacity: 0.07
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.247.427 15.772 8.1a1.28 1.28 0 0 1 .727.901 1.22 1.22 0 0 0-.727-1L2.246.322C1.294-.224.502.23.502 1.34v.1c0-1.106.792-1.565 1.745-1.013",
    opacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleStore_svg__a",
    x1: 8.698,
    x2: -2.93,
    y1: 1.178,
    y2: 12.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#008fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00acff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00c0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00cdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00d1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleStore_svg__b",
    x1: 15.888,
    x2: -0.876,
    y1: 9.001,
    y2: 9.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8a00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleStore_svg__c",
    x1: 10.792,
    x2: -4.971,
    y1: 10.589,
    y2: 26.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b11162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleStore_svg__d",
    x1: -1.353,
    x2: 5.691,
    y1: -4.732,
    y2: 2.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#328e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2d9571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15bd74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06d575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00de76"
  })))));
};
export default SvgGoogleStore;